import React from "react";
import { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getMultiAccountByCodesName } from "../../stores/services/account.service";
import { getFundByAmc } from "../../stores/services/funds.service";

const FundAccountSummary = () => {
  const amc_name = sessionStorage.getItem("amc_name") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const email = sessionStorage.getItem("email") || "";
  const [multiFunds, setMultiFunds] = useState<any>([]);
  const [apiLoading, setApiLoading] = useState<boolean>(false);

  React.useEffect(() => {
    const getfundByAmcCode = async () => {
      setApiLoading(true);
      try {
        const response = await getFundByAmc(email, amc_code);
        let fundCode = "";
        let fundObj = [] as any;
        if (!fund_code || fund_code.length === 0) {
          response.data.data.map((val) => {
            //   if (fund_code) {
            //     fundCode = fund_code;
            //   } else
            if (fundCode === "") {
              fundCode = val.symbol_code;
            } else {
              fundCode = fundCode + "," + val.symbol_code;
            }
            let tempObj = {
              fund_name: val.fund_name,
              fundCode: val.symbol_code,
            };
            fundObj.push(tempObj);
            return {
              ...val,
              label: `${val.fund_name}-${val.symbol_code}`,
              value: val.symbol_code,
            };
          });
        } else {
          fundCode = fund_code.toString();
        }
        if (fundCode !== "") {
          try {
            const res = await getMultiAccountByCodesName(email, fundCode);

            setMultiFunds(res.data.data);
          } catch (err: any) {
            if (err.response !== undefined) {
              toast.error(err.response.data.message);
            } else {
              toast.error(err.message);
            }
          }
        } else {
          toast.error("No Fund Found Against This AMC");
        }
      } catch (err: any) {
        if (err.response !== undefined) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
        setApiLoading(false);
      }
      setApiLoading(false);
    };
    getfundByAmcCode();
  }, []);

  const renderStockMarketData = () => {
    return multiFunds.map((val, index) => {
      return (
        <div className=" card" key={index}>
          <div className="card-header">
            <h4 className="card-title">
              {val.fund_name}-{" "}
              <span className="text-primary"> ({val.fund_code}) </span>
            </h4>
          </div>
          <div className="card-body">
            <table className="table ">
              <thead>
                <tr>
                  <th className="w-75">Detail</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody></tbody>
              <tbody>{renderMultiTableData(val)}</tbody>
            </table>
          </div>
        </div>
      );
    });
  };

  const renderMultiTableData = (value) => {
    if (value.data.length > 0) {
      return value.data.map((items: any, index: any) => {
        return (
          <tr key={index}>
            <td>
              {items.bank_name}-{items.account_title}-{items.account_no}
            </td>
            <td>
              {items.balance_amount.toString() === "NaN"
                ? "0"
                : parseFloat(items.balance_amount).toLocaleString()}
            </td>
          </tr>
        );
      });
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="d-flex align-items-center"></div>

                <div className=" ">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Fund Account Summary</h4>
                    </div>
                  </div>

                  {apiLoading ? (
                    <div className="d-flex justify-content-center my-5">
                      <i className="fa fa-spinner fa-spin fa-3x"></i>
                    </div>
                  ) : (
                    <div>{renderStockMarketData()}</div>
                  )}
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FundAccountSummary;
